import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import useLocation from "routing/useLocation";
import { Link, LinkContainer } from "components/common";
import { Nav, Navbar } from "components/bootstrap";
import AppConfig from "util/AppConfig";
import GlobalThroughput from "components/throughput/GlobalThroughput";
import Routes from "routing/Routes";
import BrandNavLogo from "components/navigation/NavigationBrand";
import { hoverIndicatorStyles } from "components/common/NavItemStateIndicator";
import usePluginEntities from "hooks/usePluginEntities";
import MainNavbar from "components/navigation/MainNavbar";
import useNavigationCollapse from "components/navigation/useNavigationCollapse";
import { FEATURE_FLAG } from "components/quick-jump/Constants";
import { NAV_ITEM_HEIGHT, NAVBAR_GAP } from "theme/constants";
import UserMenu from "./UserMenu";
import HelpMenu from "./HelpMenu";
import NotificationBadge from "./NotificationBadge";
import DevelopmentHeaderBadge from "./DevelopmentHeaderBadge";
import ScratchpadToggle from "./ScratchpadToggle";
import { QuickJumpModalContainer } from "../quick-jump";
const BrandLink = styled(Link)(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    min-height: ${NAV_ITEM_HEIGHT};
    color: ${theme.colors.text.primary};
    padding: 0 ${NAVBAR_GAP}px;

    &:hover,
    &:active,
    &:focus {
      text-decoration: none;
      color: ${theme.colors.text.primary};
    }
  `
);
const Brand = styled.div`
  flex: 0 0 auto;
`;
const Icons = styled.nav(
  ({ theme }) => css`
    margin-left: auto;
    flex: 0 0 auto;

    a:hover,
    a:focus-visible {
      ${hoverIndicatorStyles(theme)}
    }
  `
);
const MainNavAndNotificationBadge = styled.nav`
  display: flex;
  align-items: center;
`;
const Badges = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
`;
const Navigation = React.memo(({ pathname }) => {
  const pluginItems = usePluginEntities("navigationItems");
  const pluginBadges = usePluginEntities("navigation.badges");
  const activePluginBadges = pluginBadges.filter(({ useCondition }) => useCondition());
  const { t } = useTranslation("navigation");
  const { navbarRef, brandRef, badgesRef, iconsRef, menuRef, collapsed } = useNavigationCollapse();
  return /* @__PURE__ */ React.createElement(Navbar, { ref: navbarRef, role: "navigation" }, collapsed && /* @__PURE__ */ React.createElement(MainNavbar, { pathname, collapsed, menuRef }), /* @__PURE__ */ React.createElement(Brand, { ref: brandRef }, /* @__PURE__ */ React.createElement(BrandLink, { to: Routes.WELCOME, "aria-label": t("shell.welcome") }, /* @__PURE__ */ React.createElement(BrandNavLogo, null))), /* @__PURE__ */ React.createElement(MainNavAndNotificationBadge, { "aria-label": t("shell.main") }, !collapsed && /* @__PURE__ */ React.createElement(MainNavbar, { pathname, collapsed, menuRef }), /* @__PURE__ */ React.createElement(Badges, { ref: badgesRef }, activePluginBadges.map(({ key, component: PluginBadge }) => /* @__PURE__ */ React.createElement(PluginBadge, { key })), /* @__PURE__ */ React.createElement(NotificationBadge, null))), /* @__PURE__ */ React.createElement(Icons, { ref: iconsRef, "aria-label": t("shell.utility") }, /* @__PURE__ */ React.createElement(Nav, null, /* @__PURE__ */ React.createElement("li", null, AppConfig.isFeatureEnabled(FEATURE_FLAG) ? /* @__PURE__ */ React.createElement(QuickJumpModalContainer, null) : null), /* @__PURE__ */ React.createElement("li", null, AppConfig.isCloud() ? /* @__PURE__ */ React.createElement(GlobalThroughput, { disabled: true }) : /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.CLUSTER.NODES }, /* @__PURE__ */ React.createElement(GlobalThroughput, null))), /* @__PURE__ */ React.createElement(DevelopmentHeaderBadge, null), pluginItems.map(({ key, component: Item }) => /* @__PURE__ */ React.createElement("li", { key }, /* @__PURE__ */ React.createElement(Item, null))), /* @__PURE__ */ React.createElement(ScratchpadToggle, null), /* @__PURE__ */ React.createElement(HelpMenu, null), /* @__PURE__ */ React.createElement(UserMenu, null))));
});
const NavigationContainer = () => {
  const { pathname } = useLocation();
  return /* @__PURE__ */ React.createElement(Navigation, { pathname });
};
export default NavigationContainer;
